import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-bigcommerce-install-tracking',
  template: require('./bigcommerce_install_tracking.component.html'),
  styles: [require('./bigcommerce_install_tracking.component.scss')]

})

export class BigcommerceInstallTrackingComponent extends AccordionContentComponent {

}
